<template>
  <mi-list-item class="q-py-md">
    <mi-list-item-section>
      <!-- Component variant ID&Name or ID2&Name for old validations -->
      <mi-list-item-label
        v-if="validation"
        class="text-weight-bold q-mb-md"
        lines="3"
      >
        <mi-btn
          flat
          class="validation-explanation-item__link validation-explanation-item__hover text-subtitle2 text-weight-bold"
          @click="redirectToWindchill(item.ambiguous1Id)"
        >
          {{ item.ambiguous1Id2 }} {{ item.ambiguous1Name }}
        </mi-btn>
        -
        <mi-btn
          flat
          class="validation-explanation-item__link validation-explanation-item__hover text-subtitle2 text-weight-bold"
          @click="redirectToWindchill(item.ambiguous2Id)"
        >
          {{ item.ambiguous2Id2 }} {{ item.ambiguous2Name }}
        </mi-btn>
      </mi-list-item-label>
      <mi-list-item-label
        v-else
        class="text-weight-bold q-mb-md"
        lines="3"
      >
        {{ item.ambiguous1Id2 }} {{ item.ambiguous1Name }} -
        {{ item.ambiguous2Id2 }} {{ item.ambiguous2Name }}
      </mi-list-item-label>
      <!-- Explanation -->
      <div class="text-weight-light"> {{ item.explanation }} </div>

      <!-- Planning period range -->
      <mi-list-item-label class="q-mt-md" caption>
        {{ item.rangeFrom }} - {{ item.rangeTo }}
      </mi-list-item-label>
    </mi-list-item-section>
  </mi-list-item>
</template>

<script>
  import { createWindchillLink } from '@/utils/windchill'
  import { BOM_SHOW_AMBIGUOUS_LINK } from '@/constants'

  export default {
    name: 'BomValidationResultsElementsAmbiguousOldVersion',
    components: { },
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    computed: {
      validation() {
        return this.item.ambiguous1Id
      }
    },
    methods: {
      redirectToWindchill(ruleId) {
        const windchillLink = createWindchillLink(BOM_SHOW_AMBIGUOUS_LINK, ruleId)
        if (windchillLink) window.open(windchillLink, '_blank')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .validation-explanation {
    gap: .5rem;

    &__card {
      border-color: $mi-anthracite-100;
    }

    &__list {
      list-style-type: none;
    }
  }

  .validation-explanation-item.mi-list-item {
    min-height: auto;
  }

  .validation-explanation-item__title {
    min-width: 100px;
  }

  .validation-explanation-item__link {
    color: $mi-anthracite-800;
    margin-top: 0;
    margin-bottom: 0;
    text-decoration: none;
    padding: 0;
  }

  .validation-explanation-item__hover {
    &:hover {
      color: $mi-red-500;
      cursor: pointer;
      text-decoration: underline;
    }

    ::v-deep(.q-focus-helper) {
      /* stylelint-disable-next-line declaration-no-important */
      display: none !important;
    }
  }

  ::v-deep(.validation-explanation-item__hover.mi-btn.q-btn.q-btn--flat:hover) {
    /* stylelint-disable-next-line declaration-no-important */
    background-color: transparent !important;
    /* stylelint-disable-next-line declaration-no-important */
    color: $mi-red-500 !important;
  }
</style>
